<template>
  <vs-popup
      :active.sync="active" :title="'Segundo factor de autentificación'">
    <vs-input
      type="number"
      label="Código (6 Dígitos)"
      :danger="textError !== ''"
      :danger-text="textError"
      @keyup.prevent="validate()"
      v-model="code"></vs-input>

    <div class="mt-3 float-right">
      <vs-button ref="button" @click="confirm()">Autenticar</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "OtpTwoFactorAuthenticator",
  data: () => ({
    active: false,
    code: '',
    textError: ''
  }),
  methods: {
    show() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
    validate() {
      if(this.code.toString().length < 6) {
        this.textError = "El código debe tener 6 dígitos";
      } else {
        this.textError = "";
      }
    },
    async confirmation() {
      this.$vs.loading();

      try {
        await axios.post(`/api/auth/mfa/2fa/verify`, { code: this.code })
        return true;
      } catch (e) {
        this.$vs.loading.close();
        this.textError = e.response.data.message;
        return false;
      } finally {
        this.$vs.loading.close();
      }
    },
    async confirm() {
      this.$vs.loading();

      try {
        await axios.post(`/api/auth/mfa/2fa/verify`, {
          code: this.code
        })

        this.$emit('confirm', true)
      } catch (e) {
        this.$vs.loading.close();
        this.textError = e.response.data.message;
        this.$emit('confirm', false)
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
